import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';

/**
 * Static compass rose overlay for Leaflet maps.
 * Renders in the top-right corner by appending to the existing
 * Leaflet control container. Leaflet maps are always north-up
 * so this is a static indicator.
 */
export function MapCompass() {
  const map = useMap();
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Find the top-right control container Leaflet already creates
    const controlContainer = map.getContainer().querySelector(
      '.leaflet-control-container .leaflet-top.leaflet-right'
    );
    if (!controlContainer) return;

    const div = document.createElement('div');
    div.className = 'leaflet-control';
    div.style.pointerEvents = 'none';
    div.style.marginTop = '6px';
    div.style.marginRight = '6px';
    div.innerHTML = `
      <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="23" fill="rgba(17,24,39,0.75)" stroke="rgba(255,255,255,0.3)" stroke-width="1"/>
        <line x1="43" y1="24" x2="39" y2="24" stroke="rgba(255,255,255,0.5)" stroke-width="1"/>
        <line x1="24" y1="43" x2="24" y2="39" stroke="rgba(255,255,255,0.5)" stroke-width="1"/>
        <line x1="5" y1="24" x2="9" y2="24" stroke="rgba(255,255,255,0.5)" stroke-width="1"/>
        <polygon points="24,6 28,24 24,21 20,24" fill="#ef4444"/>
        <polygon points="24,42 20,24 24,27 28,24" fill="rgba(255,255,255,0.7)"/>
        <text x="24" y="5" text-anchor="middle" font-size="7" font-weight="bold" fill="#ef4444" font-family="sans-serif">N</text>
      </svg>
    `;

    controlContainer.appendChild(div);
    containerRef.current = div;

    return () => {
      if (containerRef.current && containerRef.current.parentNode) {
        containerRef.current.parentNode.removeChild(containerRef.current);
      }
    };
  }, [map]);

  return null;
}
